var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"banner banner--browser"},[_c('p',[_vm._v("Please update your browser to edit content. "),_c('UpdateBrowserButton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }